import Grid from '../Grid/Grid';
import type { Photo } from '../../types/photo';
import GridItem from '../GridItem/GridItem';
import PhotosGalleryItem from '../PhotosGalleryItem/PhotosGalleryItem';
interface PhotosGalleryProps {
  photos: Photo[];
  openModal: (item: Photo) => void;
}

export default function PhotosGallery({
  photos,
  openModal,
}: PhotosGalleryProps) {
  return (
    <Grid>
      {photos.map((item) => (
        <GridItem key={item.id} onClick={() => openModal(item)}>
          <PhotosGalleryItem photo={item} />
        </GridItem>
      ))}
    </Grid>
  );
}
